export const loginFormData = {
    email: '',
    password: '',
    showPassword:false,
    rememberMe: true,
};
